import { render, staticRenderFns } from "./AuditMessageCompareDialog.vue?vue&type=template&id=c649f87e&scoped=true"
import script from "./AuditMessageCompareDialog.vue?vue&type=script&lang=ts"
export * from "./AuditMessageCompareDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c649f87e",
  null
  
)

export default component.exports